<style>
#dataImportModal .v--modal-box.v--modal {
  min-height: 375px !important;
  min-width: 670px !important;
}
#dataImportModal .v-tabs__div:not(:last-child) {
  padding-right: 5px;
}
#dataImportModal .v-tabs__div {
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
#dataImportModal .checkbox--big i {
  font-size: 20px;
}
#dataImportModal .modal__footer {
  display: none !important;
}
#dataImportModal .v-btn.success {
  margin-left: 0px;
}
#dataImportModal .v-select__selection.v-select__selection--comma {
  font-size: 12px !important;
}
</style>

<template>
  <Modal
    modalName="dataImportModal"
    title="DODAWANIE WARSTWY"
    @opened="opened"
    :buttons="['']"
    @closed="closed"
  >
    <div>

      <v-tabs
        color="#2a579a"
        dark
        centered
        grow
        active-class="tab--active"
        :hide-slider="true"
        height="35"
      >
        <v-tab>WMS</v-tab>
        <v-tab-item>
          <div class="table-responsive">
            <v-subheader>Podaj adres usługi WMS aby zobaczyć dostępne warstwy (w układzie {{$root.projection}})</v-subheader>
            <v-text-field
              height="16"
              type="url"
              label="Adres usługi"
              v-model="currentWmsUrl"
            ></v-text-field>

            <template v-if="!avalibleWmsLayers">
              <v-btn
                color="success"
                @click="checkWMSGetCapabilities"
              >
                Wczytaj warstwy
              </v-btn>
              <v-btn
                color="error"
                @click="clearWMS"
              >
                Wyczyść
              </v-btn>
            </template>
            <template v-else-if="avalibleWmsLayers.length == 0">
              <p>Brak dostępnych warstw w układzie {{$root.projection}}</p>
              <v-btn
                color="error"
                @click="clearWMS"
              >
                Wyczyść
              </v-btn>
            </template>
            <template v-else>
              <v-select
                label="Wybierz warstwę"
                :items="avalibleWmsLayers"
                item-text="title"
                :return-object="true"
                v-model="currentWmsLayer"
                height="16"
              ></v-select>
              <v-text-field
                height="16"
                label="Wyświetlana nazwa"
                v-model="displayNameWmsLayer"
              ></v-text-field>
              <v-checkbox
                class="checkbox--big"
                v-model="publicWmsLayer"
                label="Warstwa publiczna"
              ></v-checkbox>
              <v-btn
                color="success"
                :disabled="!currentWmsLayer"
                @click="sendWMS"
              >
                Dodaj WMS
              </v-btn>
              <v-btn
                color="error"
                @click="clearWMS"
              >
                Wyczyść
              </v-btn>
            </template>
          </div>
        </v-tab-item>

        <v-tab>SHP</v-tab>
        <v-tab-item>
          <div class="widget-body">
            <div class="table-responsive">
              <v-subheader>Przesyłanie plików Shapefile</v-subheader>
              <ul>
                <li>Dane przestrzenne muszą posiadać kodowanie znaków UTF-8</li>
                <li>Akceptowane są pliki SHP, SHX i DBF</li>
              </ul>
              <v-text-field
                height="16"
                label="Nazwa warstwy użytkownika"
                v-model="userLayerName"
              ></v-text-field>
              <vue-dropzone
                ref="dropzoneUserLayerSHP"
                id="dropzoneUserLayerSHP"
                :options="userLayerDropOptionsSHP"
                :useCustomSlot="true"
                @vdropzone-sending-multiple="sendingEventUserLayerSHP"
                @vdropzone-error-multiple="sendingError"
                @vdropzone-success-multiple="sendingCompleted"
                @vdropzone-files-added="addedSHPFile"
                @vdropzone-queue-complete="globalCompleteUserLayer"
              >
                <div class="dropzone-custom-content">
                  <h3
                    class="dropzone-custom-title font--primary"
                    style="color:rgb(42,87,154)"
                  >Przeciągnij załączniki do wysłania</h3>
                  <div class="subtitle font--primary">lub kliknij i wybierz je ze swojego komputera</div>
                </div>
              </vue-dropzone>
              <div v-if="isFileSHP">
                <v-text-field
                  height="16"
                  label="SRID"
                  v-model="userLayerSrid"
                ></v-text-field>
                <v-checkbox
                  class="checkbox--big"
                  v-model="userLayerPublic"
                  label="Warstwa publiczna"
                ></v-checkbox>

                <v-btn
                  color="success"
                  @click="sendUserLayerSHP"
                >
                  Wyślij
                </v-btn>
                <v-btn
                  color="error"
                  @click="clearUserLayerSHP"
                >
                  Wyczyść
                </v-btn>
              </div>
            </div>
          </div>
        </v-tab-item>

        <v-tab>CSV</v-tab>
        <v-tab-item>
          <div class="widget-body">
            <div class="table-responsive">
              <v-subheader>Przesyłanie plików CSV</v-subheader>
              <ul>
                <li>Dane przestrzenne muszą posiadać kodowanie znaków UTF-8</li>
                <li>Akceptowane są jedynie pliki CSV</li>
              </ul>
              <v-text-field
                height="16"
                label="Nazwa warstwy użytkownika"
                v-model="userLayerName"
              ></v-text-field>
              <vue-dropzone
                ref="dropzoneUserLayerCSV"
                id="dropzoneUserLayerCSV"
                :options="userLayerDropOptionsCSV"
                :useCustomSlot="true"
                @vdropzone-sending="sendingEventUserLayerCSV"
                @vdropzone-error="sendingError"
                @vdropzone-success="sendingCompleted"
                @vdropzone-files-added="addedCSVFile"
                @vdropzone-removed-file="clearUserLayerCSV"
                @vdropzone-queue-complete="globalCompleteUserLayer"
              >
                <div class="dropzone-custom-content">
                  <h3
                    class="dropzone-custom-title font--primary"
                    style="color:rgb(42,87,154)"
                  >Przeciągnij załączniki do wysłania</h3>
                  <div class="subtitle font--primary">lub kliknij i wybierz je ze swojego komputera</div>
                </div>
              </vue-dropzone>
              <div v-if="isFileCSV">
                <v-text-field
                  height="16"
                  label="SRID"
                  v-model="userLayerSrid"
                ></v-text-field>
                <v-select
                  height="16"
                  :items="userLayerColumns"
                  label="X"
                  :return-object="true"
                  item-text="name"
                  v-model="userLayerX"
                ></v-select>
                <v-select
                  height="16"
                  :items="userLayerColumns"
                  label="Y"
                  :return-object="true"
                  item-text="name"
                  v-model="userLayerY"
                ></v-select>
                <v-select
                  label="Separator"
                  :items="separators"
                  item-text="pl"
                  :return-object="true"
                  v-model="userLayerSeparator"
                  height="16"
                ></v-select>
                <v-text-field
                  height="16"
                  label="Kodowanie"
                  v-model="userLayerEncoding"
                ></v-text-field>
                <v-flex xs12>
                  <span style="display: flex; width: 100%">
                    <v-subheader class="font--primary">Kolumny</v-subheader>
                  </span>
                  <v-list>
                    <v-list-tile class="list--el">
                      <v-list-tile-title class="list--el--bold">Nazwa</v-list-tile-title>
                      <v-list-tile-title class="list--el--bold">Typ danych</v-list-tile-title>
                    </v-list-tile>
                    <template v-for="(field,index) in userLayerColumns">
                      <v-list-tile
                        class="list--el"
                        :key="index"
                      >
                        <v-list-tile-title>{{field.name}}</v-list-tile-title>
                        <v-list-tile-title>
                          <v-select
                            style="width: 60%; top:-10px;"
                            height="14"
                            hide-details
                            :items="columnTypes"
                            placeholder="Typ kolumny"
                            :return-object="true"
                            item-text="name"
                            v-model="field.data_type"
                          ></v-select>
                        </v-list-tile-title>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-flex>
                <v-checkbox
                  class="checkbox--big"
                  v-model="userLayerPublic"
                  label="Warstwa publiczna"
                  @click="changeDataTypes"
                ></v-checkbox>
                <v-btn
                  color="success"
                  @click="sendUserLayerCSV"
                >
                  Wyślij
                </v-btn>
                <v-btn
                  color="error"
                  @click="clearUserLayerCSV"
                >
                  Wyczyść
                </v-btn>
              </div>
            </div>
          </div>
        </v-tab-item>
      </v-tabs>
    </div>
  </Modal>
</template>

<script>
//<editor-fold defaultstate="collapsed" desc="imports">
import Modal from "../../../shared/Modal";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import Papaparse from "papaparse";

import {GeoJSON} from "ol/format";
import WMSCapabilities from "../../../../utils/WMSCapabilities.js";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
import filter from "lodash/filter";
import each from "lodash/each";
import keyBy from "lodash/keyBy";
import mapValues from "lodash/mapValues";
import flatten from "lodash/flatten";
import uniq from "lodash/uniq";
import sortBy from "lodash/sortBy";
import includes from "lodash/includes";
import isArray from "lodash/isArray";
mixin(_, {
  chain,
  map,
  filter,
  keyBy,
  mapValues,
  each,
  flatten,
  uniq,
  sortBy,
  includes,
  isArray
});
_.value = value;
_.prototype.value = value;
//</editor-fold>

export default {
  components: {
    Modal,
    vueDropzone: vue2Dropzone
  },
  data() {
    const self = this;
    return {
      uploadView: "files",
      upload_layer: {},
      activeTab: undefined,
      progress: false,
      //<editor-fold defaultstate="collapsed" desc="user layers">
      userLayerDropOptionsSHP: {
        url: `${this.$store.getters.getApiURL}/users_layers/shp?token=${
          this.$store.getters.getToken
          }`,
        addRemoveLinks: true,
        autoProcessQueue: false,
        maxFiles: 3,
        parallelUploads: 3,
        method: "post",
        uploadMultiple: true,
        acceptedFiles: ".shp,.shx,.dbf",
        paramName(i) {
          const files = self.$refs.dropzoneUserLayerSHP.getActiveFiles();
          const file = files[i];
          return file.name.split(".")[1];
        },
        success: function (file, response) {
          self.$root.$emit(
            "showSnackbar",
            "success",
            `Pomyślnie dodano nową warstwę: ${response.name}`
          );
        },
        error: function (file, response) {
          self.$root.$emit("showSnackbar", "error", `${response.message}`);
        },
        dictRemoveFile: "Usuń plik",
        dictCancelUpload: "Anuluj wysyłanie",
        dictUploadCanceled: "Anulowano wysyłanie.",
        dictCancelUploadConfirmation:
          "Czy na pewno chcesz anulować to przesyłanie?"
      },
      userLayerDropOptionsCSV: {
        url: `${this.$store.getters.getApiURL}/users_layers/csv?token=${
          this.$store.getters.getToken
          }`,
        addRemoveLinks: true,
        autoProcessQueue: false,
        maxFiles: 3,
        parallelUploads: 3,
        method: "post",
        acceptedFiles: ".csv",
        success: function (file, response) {
          self.$root.$emit(
            "showSnackbar",
            "success",
            `Pomyślnie dodano nową warstwę: ${response.name}!`
          );
        },
        error: function (file, response) {
          self.$root.$emit("showSnackbar", "error", `${response.message}`);
        },
        dictRemoveFile: "Usuń plik",
        dictCancelUpload: "Anuluj wysyłanie",
        dictUploadCanceled: "Anulowano wysyłanie.",
        dictCancelUploadConfirmation:
          "Czy na pewno chcesz anulować to przesyłanie?"
      },
      userLayerDropOptionsTable: {
        url: `${this.$store.getters.getApiURL}/users_layers/table?token=${
          this.$store.getters.getToken
          }`,
        addRemoveLinks: true,
        autoProcessQueue: false,
        maxFiles: 3,
        parallelUploads: 3,
        method: "post",
        acceptedFiles: ".csv",
        success: function (file, response) {
          self.$root.$emit(
            "showSnackbar",
            "success",
            `Pomyślnie dodano nową warstwę: ${response.name}!`
          );
        },
        error: function (file, response) {
          self.$root.$emit("showSnackbar", "error", `${response.message}`);
        },
        dictRemoveFile: "Usuń plik",
        dictCancelUpload: "Anuluj wysyłanie",
        dictUploadCanceled: "Anulowano wysyłanie.",
        dictCancelUploadConfirmation:
          "Czy na pewno chcesz anulować to przesyłanie?"
      },
      userLayerDropOptionsGeocode: {
        url: `${this.$store.getters.getApiURL}/users_layers/geocode?token=${
          this.$store.getters.getToken
          }`,
        addRemoveLinks: true,
        autoProcessQueue: false,
        maxFiles: 3,
        parallelUploads: 3,
        method: "post",
        acceptedFiles: ".csv",
        success: function (file, response) {
          self.$root.$emit(
            "showSnackbar",
            "success",
            `Pomyślnie dodano nową warstwę: ${response.name}!`
          );
        },
        error: function (file, response) {
          self.$root.$emit("showSnackbar", "error", `${response.message}`);
        },
        dictRemoveFile: "Usuń plik",
        dictCancelUpload: "Anuluj wysyłanie",
        dictUploadCanceled: "Anulowano wysyłanie.",
        dictCancelUploadConfirmation:
          "Czy na pewno chcesz anulować to przesyłanie?"
      },
      userLayerName: "",
      userLayerSrid: "2180",
      userLayerX: "",
      userLayerY: "",
      userLayerSeparator: "",
      userLayerPublic: false,
      userLayerStreet: "",
      userLayerCity: "",
      userLayerStreet: "",
      userLayerNumber: "",
      userLayerEncoding: "utf-8",
      columnsCounter: 1,
      separators: [
        {
          name: "TAB",
          pl: "tabulator"
        },
        {
          name: "COMMA",
          pl: "przecinek"
        },
        {
          name: "SPACE",
          pl: "spacja"
        },
        {
          name: "SEMICOLON",
          pl: "średnik"
        }
      ],
      columnTypes: [
        {
          name: "Tekst",
          key: "text"
        },
        {
          name: "Liczba całkowita",
          key: "integer"
        },
        {
          name: "Liczba rzeczywista",
          key: "float"
        }
      ],
      //</editor-fold>
      userLayerColumns: [],
      //<editor-fold defaultstate="collapsed" desc="wodkan">
      wodkanDropOptions: {
        url: `${this.$store.getters.getApiURL}/upload?token=${
          this.$store.getters.getToken
          }`,
        addRemoveLinks: true,
        autoProcessQueue: false,
        maxFiles: 3,
        parallelUploads: 3,
        method: "post",
        uploadMultiple: true,
        acceptedFiles: ".shp,.shx,.dbf",
        paramName(i) {
          const files = self.$refs.dropzoneWodkan.getActiveFiles();
          const file = files[i];
          return file.name.split(".")[1];
        },

        dictRemoveFile: "Usuń plik",
        dictCancelUpload: "Anuluj wysyłanie",
        dictUploadCanceled: "Anulowano wysyłanie.",
        dictCancelUploadConfirmation:
          "Czy na pewno chcesz anulować to przesyłanie?"
      },
      geometryType: null,
      session_id: null,
      uploadedFields: [],
      //</editor-fold>

      //<editor-fold defaultstate="collapsed" desc="user layers">
      tempLayerDropOptions: {
        url: "/",
        addRemoveLinks: true,
        autoProcessQueue: false,
        maxFiles: 1,
        parallelUploads: 1,
        acceptedFiles: ".geojson",

        dictRemoveFile: "Usuń plik",
        dictCancelUpload: "Anuluj wysyłanie",
        dictUploadCanceled: "Anulowano wysyłanie.",
        dictCancelUploadConfirmation:
          "Czy na pewno chcesz anulować to przesyłanie?"
      },
      tempLayerName: "",
      //</editor-fold>

      //<editor-fold defaultstate="collapsed" desc="wms">
      avalibleWmsLayers: false,
      currentWmsLayer: false,
      currentWmsUrl: "",
      displayNameWmsLayer: "",
      publicWmsLayer: false,
      //</editor-fold>
      isFileTable: false,
      isFileCSV: false,
      isFileGeocode: false,
      isFileSHP: false
    };
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    srid() {
      return this.$store.getters.getSrid;
    },
    layers() {
      const self = this;
      return _.chain(
        self.map
          .getLayers()
          .item(2)
          .getLayers()
          .getArray()
      )
        .filter(layer =>
          _.includes(["water", "sewer"], layer.get("layer_type"))
        )
        .map(layer => {
          return {
            name: layer.get("full_name"),
            key: layer.get("full_type"),
            fields: layer.get("fields"),
            geometry_type: layer.get("geometry_type"),
            instance: self.$root.createProxy(layer)
          };
        })
        .keyBy("key")
        .value();
    },
    uploadLayers() {
      if(this.geometryType === null) {
        return this.layers;
      }
      if(this.geometryType === "invalid") {
        return [];
      }
      return _.filter(
        this.layers,
        (lyr, k) => lyr.geometry_type === this.geometryType
      );
    },
    apiURL() {
      return this.$store.getters.getApiURL;
    }
  },
  watch: {
    currentWmsLayer(_new) {
      this.displayNameWmsLayer = _new.title;
    }
  },
  created() {},
  methods: {
    opened() {},
    show(title) {
      if(this.activeModals.indexOf(title) === -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    sendMapData() {
      const self = this;
      const input = document.getElementById("map-file-picker");
      if(input.files[0] && input.files[0].name.endsWith(".map")) {
        self.mapFile = input.files[0];
        self.sendMapFile();
      } else {
        self.$root.$emit(
          "showSnackbar",
          "error",
          "Nie podano poprawnego pliku MAP!"
        );
      }
    },
    sendMapFile() {
      const self = this;
      self.uploadView = "wait";
      const fd = new FormData();
      fd.append("map", this.mapFile);
      fetch("/mapfile", {
        method: "POST",
        body: fd
      })
        .then(response => response.json())
        .then(data => {
          self.$root.$emit(
            "showSnackbar",
            "error",
            `Zakończono przesyłanie danych. Dodano ${data.count} obiektów`
          );
        })
        .catch(() => {
          self.$root.$emit(
            "showSnackbar",
            "error",
            "Wystąpił bład podczas dodawania obiektów"
          );
        })
        .finally(() => {
          self.uploadView = "files";
          self.clearMapFile();
        });
    },
    clearMapFile() {
      this.mapFile = false;
    },

    //<editor-fold defaultstate="collapsed" desc="wodkan">
    sendWodkan() {
      this.$refs.dropzoneWodkan.processQueue();
    },
    clearWodkan() {
      this.$refs.dropzoneWodkan.removeAllFiles();
    },
    sendingEventWodkan(files, xhr, formData) {
      if(!this.validateFiles(files)) {
        this.$root.$emit(
          "showSnackbar",
          "error",
          "Nie dodano wszystkich wymaganych plików (shp, shx i dbf)!"
        );
        throw "Cancel upload";
      }
      this.progress = true;
    },
    globalCompleteWodkan(files) {
      this.progress = false;
    },
    sendingCompletedWodkan(files, data, i) {
      this.session_id = data.session_id;
      this.geometryType = data.geometryType;
      this.uploadedFields = data.fields;
      this.uploadView = "fields";
    },

    removeFilesWodkan() {
      //Usunięcie przesłanych plików z serwera
      const self = this;
      fetch(`/upload/${self.session_id}`, {
        method: "DELETE",
        body: JSON.stringify({})
      })
        .then(response => response.json())
        .catch(() => {});
    },
    saveDataWodkan() {
      const self = this;

      self.progress = true;
      const data = {
        fields: self.getFieldsMap(),
        filename: self.shpFile.name,
        table: self.upload_layer.type
      };

      fetch(`/upload/${self.session_id}`, {
        method: "POST",
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(data => {
          self.$root.$emit(
            "showSnackbar",
            "error",
            `Zakończono operację. Dodano ${data.count} obiektów.`
          );
          self.progress = false;
          self.clearDataWodkan();
        })
        .catch(() => {
          self.uploadView = "fields";
          self.$root.$emit("showSnackbar", "error", data.responseJSON.error);
        });
    },
    clearDataWodkan() {
      //Usunięcie plików z serwera i wyczyszczenie dodanych plików
      this.clearWodkan();
      this.removeFilesWodkan();
      this.uploadView = "files";
    },
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="base">
    validateFiles(files) {
      return (
        _(files)
          .map(file => file.name.toLocaleLowerCase().split(".")[1])
          .filter(
            ext =>
              "shp" === ext || "shx" === ext || "dbf" === ext || ext === "csv"
          )
          .value().length === 3
      );
    },
    sendingError(files, message, xhr) {
      this.$root.$emit(
        "showSnackbar",
        "error",
        `${message.message}`
      );
      return false;
    },
    filesAdded(files) {
      for(let el of document.querySelectorAll(".dz-remove")) {
        el.innerText = "X";
      }
      for(let el of document.querySelectorAll(".dz-complete > a")) {
        el.innerText = "X";
      }
    },
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="user layers">
    sendingEventUserLayerSHP(files, xhr, formData) {
      if(!this.validateFiles(files)) {
        this.$root.$emit(
          "showSnackbar",
          "error",
          "Nie dodano wszystkich wymaganych plików (shp, shx i dbf)!"
        );
        throw "Cancel upload";
      }
      /*files.forEach((file) => {
       formData.append(file.name.split('.')[1], file.name);
       });*/
      formData.append("layer_name", this.userLayerName);
      formData.append("srid", this.userLayerSrid);
      this.lastPayload = {
        name: this.userLayerName,
        public: this.userLayerPublic
      };
      this.progress = true;
    },
    // changeDataTypes() {
    //   return this.userLayerColumns.map((column, index) => {
    //     if(column.data_type == "Liczba całkowita") {
    //       let tempColumn = JSON.parse(JSON.stringify(column));
    //       tempColumn.data_type = "int";
    //       return tempColumn;
    //     } else if(column.data_type == "Liczba rzeczywista") {
    //       let tempColumn = JSON.parse(JSON.stringify(column));
    //       tempColumn.data_type = "float";
    //       return tempColumn;
    //     } else {
    //       let tempColumn = JSON.parse(JSON.stringify(column));
    //       tempColumn.data_type = "text";
    //       return tempColumn;
    //     }
    //   })
    // },
    changeDataTypes() {
      return this.userLayerColumns.map((column, index) => {
        column = JSON.parse(JSON.stringify(column))
        column.data_type = column.data_type.key;
        return column;
      });
    },
    sendingCompleted(file, response) {
      this.lastPayload.table = response.table;
   
      this.$store.dispatch("getUserLayerMetadata", response.table)
        .then((data) => {

          _.each(data, (v, k) => {
            this.lastPayload[k] = v;
          })

          this.$root.$emit("addUserLayer", this.lastPayload);
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie dodano warstwę użytkownika"
          );
        })
      return true;
    },
    sendingEventUserLayerCSV(files, xhr, formData) {
      if(!files.name.split(".")[1] === "csv") {
        this.$root.$emit(
          "showSnackbar",
          "error",
          "Nie dodano wszystkich wymaganych plików"
        );
        throw "Cancel upload";
      }

      const fields = this.changeDataTypes();
      formData.append("layer_name", this.userLayerName);
      formData.append("srid", this.userLayerSrid);
      formData.append("public", this.userLayerPublic);
      formData.append("x", this.userLayerX.name);
      formData.append("y", this.userLayerY.name);
      formData.append("separator", this.userLayerSeparator.name);
      formData.append("fields", JSON.stringify(fields));
      this.lastPayload = {
        name: this.userLayerName,
        public: this.userLayerPublic,
        fields,
      };
      this.progress = true;
    },
    sendingEventUserLayerGeocode(files, xhr, formData) {
      if(!files.name.split(".")[1] == "csv") {
        this.$root.$emit(
          "showSnackbar",
          "error",
          "Nie dodano wszystkich wymaganych plików"
        );
        throw "Cancel upload";
      }

      const fields = this.changeDataTypes();
      formData.append("layer_name", this.userLayerName);
      formData.append("public", this.userLayerPublic);
      formData.append("separator", this.userLayerSeparator.name);
      formData.append("city", this.userLayerCity.name);
      formData.append("street", this.userLayerStreet.name);
      formData.append("number", this.userLayerNumber.name);
      formData.append("fields", JSON.stringify(fields));
      this.lastPayload = {
        name: this.userLayerName,
        public: this.userLayerPublic,
        fields,
      };
      this.progress = true;
    },
    sendingEventUserLayerTable(files, xhr, formData) {
      if(!files.name.split(".")[1] == "csv") {
        this.$root.$emit(
          "showSnackbar",
          "error",
          "Nie dodano wszystkich wymaganych plików"
        );
        throw "Cancel upload";
      }

      const fields = this.changeDataTypes();
      formData.append("layer_name", this.userLayerName);
      formData.append("public", this.userLayerPublic);
      formData.append("separator", this.userLayerSeparator.name);
      formData.append("fields", JSON.stringify(fields));
      this.lastPayload = {
        name: this.userLayerName,
        public: this.userLayerPublic,
        fields,
      };
      this.progress = true;
    },
    globalCompleteUserLayer(files) {
      this.$refs.dropzoneUserLayerSHP.removeAllFiles();
      /* this.$refs.dropzoneUserLayerGeocode.removeAllFiles();
      this.$refs.dropzoneUserLayerCSV.removeAllFiles();
      this.$refs.dropzoneUserLayerTable.removeAllFiles(); */
      this.userLayerName = "";
      this.userLayerSrid = "";
      this.userLayerX = "";
      this.userLayerY = "";
      this.userLayerPublic = false;
      this.userLayerSeparator = "";
      this.userLayerCity = "";
      this.userLayerStreet = "";
      this.userLayerNumber = "";
      this.userLayerEncoding = "";
      this.userLayerColumns = [];
      this.progress = false;
      this.isFileTable = false;
      this.isFileCSV = false;
      this.isFileGeocode = false;
    },
    sendUserLayerSHP() {
      this.$refs.dropzoneUserLayerSHP.processQueue();
    },
    sendUserLayerCSV() {
      this.$refs.dropzoneUserLayerCSV.processQueue();
    },
    sendUserLayerGeocode() {
      this.$refs.dropzoneUserLayerGeocode.processQueue();
    },
    sendUserLayerTable() {
      this.$refs.dropzoneUserLayerTable.processQueue();
    },
    clearUserLayerCSV() {
      this.userLayerName = "";
      this.userLayerSrid = "";
      this.userLayerX = "";
      this.userLayerY = "";
      this.userLayerPublic = false;
      this.userLayerSeparator = "";
      this.userLayerColumns = [];
      this.$refs.dropzoneUserLayerCSV.removeAllFiles();
    },
    clearUserLayerSHP() {
      this.userLayerName = "";
      this.userLayerSrid = "";
      this.userLayerPublic = false;
      this.$refs.dropzoneUserLayerSHP.removeAllFiles();
    },
    clearUserLayerGeocode() {
      this.userLayerName = "";
      this.userLayerCity = "";
      this.userLayerStreet = "";
      this.userLayerNumber = "";
      this.userLayerPublic = false;
      this.userLayerSeparator = "";
      this.userLayerColumns = [];
      this.$refs.dropzoneUserLayerGeocode.removeAllFiles();
    },
    clearUserLayerTable() {
      this.userLayerName = "";
      this.userLayerPublic = false;
      this.userLayerSeparator = "";
      this.userLayerColumns = [];
      this.$refs.dropzoneUserLayerTable.removeAllFiles();
    },
    addedSHPFile() {
      this.isFileSHP = true;
    },
    addedCSVFile(files) {
      //this.$refs.dropzoneUserLayerCSV
      let self = this;
      this.isFileCSV = true;
      Papaparse.parse(files[0], {
        complete(results) {
          results.data[0].forEach(column => {
            self.userLayerColumns.push({
              name: column,
              data_type: self.columnTypes[0]
            });
          });
        }
      });
    },
    addedGeocodeFile(files) {
      //this.$refs.dropzoneUserLayerGeocode.getAcceptedFiles()
      let self = this;
      this.isFileGeocode = true;
      Papaparse.parse(files[0], {
        complete(results) {
          results.data[0].forEach(column => {
            self.userLayerColumns.push({
              name: column,
              data_type: self.columnTypes[0]
            });
          });
        }
      });
    },
    addedTableFile(files) {
      let self = this;
      this.isFileTable = true;
      Papaparse.parse(files[0], {
        complete(results) {
          results.data[0].forEach(column => {
            self.userLayerColumns.push({
              name: column,
              data_type: self.columnTypes[0]
            });
          });
        }
      });
    },
    removedFiles() {
      this.clearUserLayerSHP;
    },
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="user layers">
    addTempLayer(empty = false) {
      if(this.tempLayerName.trim() === '') {
        this.$root.$emit("showSnackbar", "error", `Brak nazwy warstwy`);
        return;
      }

      if(empty) {
        const layer = {
          id: this.$root.generateID(),
          fields: [{
            name: 'ID'
          }],
          geometry_type: "any",
          name: this.tempLayerName
        };

        this.$store.commit("addTempLayer", layer);
        this.$root.$emit("addTempLayer", layer, []);
        this.clearTempLayer();
        return;
      }

      const files = this.$refs.dropzoneTempLayer.getActiveFiles();
      if(files.length !== 1) {
        this.$root.$emit("showSnackbar", "error", `Brak dodanego pliku`);
        return;
      }

      const layer = {
        id: this.$root.generateID(),
        fields: [],
        geometry_type: "any",
        name: this.tempLayerName
      };

      this.readFileContent(files[0])
        .then(content => new GeoJSON().readFeatures(content))
        .then(features => {
          layer.fields = this.getFields(features);
          layer.geometry_type = this.getGeometryType(features);
          this.$store.commit("addTempLayer", layer);
          this.$root.$emit("addTempLayer", layer, features);
          this.clearTempLayer();
        });
    },
    clearTempLayer() {
      this.tempLayerName = "";
      this.$refs.dropzoneTempLayer.removeAllFiles();
    },
    readFileContent(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = () => {
          reject(reader.result);
        };

        reader.readAsText(file);
      });
    },
    getFields(features) {
      let header = _(features)
        .map(feature => Object.keys(feature.getProperties()))
        .flatten()
        .uniq()
        .sortBy()
        .value();
      header.splice(header.indexOf("geometry"), 1);
      return _.map(header, column => ({
        name: column
      }));
    },
    getGeometryType(features) {
      let geometryTypes = _(features)
        .map(feature => feature.getGeometry())
        .filter((geometry) => geometry !== null)
        .map(geometry => geometry.getType())
        .uniq()
        .value();

      if(geometryTypes.length === 1) {
        //jeżeli elementy są jednego typu
        geometryTypes = geometryTypes[0].toLowerCase();
        switch(geometryTypes) {
          case 'point':
          case 'linestring':
          case 'polygon':
            return geometryTypes;
        }
        //możliwe rysowanir tylko punktów, lini, wielokątów
      }

      return 'any';
    },
    closed() {
      this.userLayerName = "";
      this.userLayerSrid = "";
      this.userLayerX = "";
      this.userLayerY = "";
      this.userLayerCity = "";
      this.userLayerStreet = "";
      this.userLayerNumber = "";
      this.userLayerPublic = false;
      this.userLayerSeparator = "";
      this.userLayerColumns = [];
      this.isFileTable = false;
      this.isFileCSV = false;
      this.isFileGeocode = false;
    },
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="wms">
    checkWMSGetCapabilities() {
      const self = this;
      //obsługa GetCapabilities

      //Czyszczenie zmiennych
      self.avalibleWmsLayers = [];
      self.currentWmsLayer = false;
      if(
        !_.startsWith(self.currentWmsUrl, "http://") &&
        !_.startsWith(self.currentWmsUrl, "https://")
      ) {
        self.currentWmsUrl = `http://${self.currentWmsUrl}`;
      }

      const format = new WMSCapabilities();

      function getLayers(layers) {
        const result = [];

        if(!_.isArray(layers)) {
          layers = [layers];
        }

        _.each(layers, layer => {
          if("Style" in layer || "Name" in layer) {
            result.push(layer);
          }

          if("Layer" in layer) {
            result.push(...getLayers(layer.Layer));
          }
        });

        return result;
      }
      function getFormats(Capability) {
        return Capability.Request.GetMap.Format;
      }

      //Pobranie danych GetCapabilities przez proxy
      return (
        fetch(`${self.apiURL}/get_xml?token=${this.$store.getters.getToken}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            url: self.currentWmsUrl
          })
        })
          //https://mapy.geoportal.gov.pl/wss/service/img/guest/ORTO/MapServer/WMSServer?REQUEST=GetCapabilities&SERVICE=WMS
          .then(response => response.text())
          .then(data => {
            //Parsowanie przez OL GetCapabilities
            let result = format.read(data);

            //Wyciągnięcie informacji o dostępnych warstwach
            //TODO: dodać obsługę nestedlayers
            if(!result || typeof result.Capability === "undefined") {
              return false;
            }

            let parsedLayers = [];
            _.each(getLayers(result.Capability), (layer, idx) => {
              parsedLayers.push({
                title: layer.Title,
                layer: layer.Name,
                extents: _(layer.BoundingBox)
                  .map(v => ({
                    key: v.SRS || v.CRS,
                    value: v.extent
                  }))
                  .keyBy("key")
                  .mapValues("value")
                  .value(),
                epsgs: layer.SRS || layer.CRS || [],
                version: result.version,
                formats: getFormats(result.Capability)
              });
            });

            self.avalibleWmsLayers = _.filter(parsedLayers, (v, k) =>
              _.includes(v.epsgs, self.$root.projection)
            );
            return true;
          })
          .catch(err => {
            return false;
          })
          .then(value => {
            if(!value) {
              self.$root.$emit(
                "showSnackbar",
                "error",
                "Nie udało się poprać odpowiednich warstw"
              );
            }
          })
      );
    },
    clearWMS() {
      this.avalibleWmsLayers = false;
      this.currentWmsLayer = false;
      this.currentWmsUrl = "";
      this.displayNameWmsLayer = "";
      this.publicWmsLayer = false;
    },
    sendWMS() {
      const self = this;

      const url = self.currentWmsUrl.split("?")[0];
      const params = {
        LAYERS: self.currentWmsLayer.layer,
        VERSION: self.currentWmsLayer.version,

        extents: self.currentWmsLayer.extents[self.$root.projection]
        //title : self.currentWmsLayer.title,
      };
      if(
        _.includes(["1.0.0", "1.1.0", "1.1.1"], self.currentWmsLayer.version)
      ) {
        params.SRS = self.$root.projection;
      } else {
        params.CRS = self.$root.projection;
      }

      if(_.includes(self.currentWmsLayer.formats, "image/png")) {
        params.FORMAT = "image/png";
      } else if(_.includes(self.currentWmsLayer.formats, "image/jpeg")) {
        params.FORMAT = "image/jpeg";
      } else {
        params.FORMAT = self.currentWmsLayer.formats[0];
      }

      const payload = {
        display_name: self.displayNameWmsLayer,
        name: self.currentWmsLayer.title,
        parameters: params,
        public: self.publicWmsLayer,
        url
      };

      fetch(`${self.apiURL}/wms?token=${this.$store.getters.getToken}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      })
        .then(response =>
          response.status === 200
            ? response.json().then(data => [response.status, data])
            : response.text().then(data => [response.status, data])
        )
        .then(([status, data]) => {
          if(status === 200) {
						payload.user = this.$store.getters.getUser.id;
            payload.id = data.inserted;
            self.$root.$emit("addWMSLayer", payload, true);
          } else {
            self.$root.$emit("showSnackbar", "error", data);
          }
          self.clearWMS();
        })
        .catch(err => {
          self.$root.$emit(
            "showSnackbar",
            "error",
            "Nie udało się dodać WMS na serwerze"
          );
        });
    }
    //</editor-fold>
  },
  mounted() {
    this.$root.$on("fieldSavedDataImportModal", this.fieldSaved);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/settings/modals/DataImportModal.vue